import cx from "classnames"
import { cloneElement, isValidElement } from "react"
import type { ButtonProps } from "../Buttons/Button/type"

export type BannerPropsType = React.PropsWithChildren<{
  title?: string
  cta?: React.ReactNode
  illustrationUrl?: string
  illustrationHeight?: number // optional: to prevent layout shifting when discovering the real image height on load
  variant: "secondary" | "tertiary" | "business"
  className?: string
}>

export const Banner = ({
  title,
  children,
  cta,
  variant = "secondary",
  illustrationUrl,
  illustrationHeight,
  className,
}: BannerPropsType) => {
  // force CTA to match Banner variant
  const enforcedCTA =
    cta && isValidElement<ButtonProps>(cta)
      ? cloneElement(cta, {
          size: "small",
          variant,
        })
      : cta

  return (
    <div
      className={cx(
        "cobalt-banner",
        {
          "cobalt-banner--secondary": variant === "secondary",
          "cobalt-banner--tertiary": variant === "tertiary",
          "cobalt-banner--business": variant === "business",
        },
        className,
      )}
    >
      <div className="cobalt-banner__content">
        {title && <div className="cobalt-banner__title">{title}</div>}
        <div className="cobalt-banner__body">{children}</div>
        {enforcedCTA}
      </div>
      {illustrationUrl && (
        <img
          alt={title ?? ""}
          className="cobalt-banner__illustration"
          src={illustrationUrl}
          style={
            illustrationHeight
              ? { height: `${illustrationHeight}px` }
              : undefined
          }
        />
      )}
    </div>
  )
}

export default Banner
